import http from '@/libs/axios'

export const employeeCentre = {
  namespaced: true,
  state: {
    departments: [],
    employees: [],
    stats: {
      staff: 0,
      union_executives: 0,
      active_records: 0,
    },
    currentEmployee: null,
  },
  mutations: {
    setDepartments(state, departments) {
      state.departments = departments
    },
    setEmployees(state, payload) {
      state.employees = payload.employees || []
      state.stats = payload.stats || state.stats
    },
    setCurrentEmployee(state, employee) {
      state.currentEmployee = employee
    },
    addDepartment(state, department) {
      state.departments = [department, ...state.departments]
    },
    updateDepartment(state, department) {
      state.departments = state.departments.map(d => (d.id === department.id ? department : d))
    },
    removeDepartment(state, id) {
      state.departments = state.departments.filter(d => d.id !== id)
    },
  },
  actions: {
    fetchDepartments({ commit }) {
      return http.get('employee-centre/departments').then(res => {
        commit('setDepartments', res.data)
        return res.data
      })
    },
    createDepartment({ commit }, data) {
      return http.post('employee-centre/departments', data).then(res => {
        commit('addDepartment', res.data)
        return res.data
      })
    },
    updateDepartment({ commit }, { id, data }) {
      return http.post(`employee-centre/departments/${id}`, data).then(res => {
        commit('updateDepartment', res.data)
        return res.data
      })
    },
    deleteDepartment({ commit }, id) {
      return http.delete(`employee-centre/departments/${id}`).then(() => {
        commit('removeDepartment', id)
      })
    },
    fetchEmployees({ commit }, query = {}) {
      const params = new URLSearchParams({
        search: query.search || '',
        employee_type: query.employee_type || '',
      })
      return http.get(`employee-centre/employees?${params.toString()}`).then(res => {
        commit('setEmployees', res.data)
        return res.data
      })
    },
    fetchEmployee({ commit }, id) {
      return http.get(`employee-centre/employees/${id}`).then(res => {
        commit('setCurrentEmployee', res.data)
        return res.data
      })
    },
    createEmployee(_, data) {
      return http.post('employee-centre/employees', data).then(res => res.data)
    },
    updateEmployee(_, { id, data }) {
      return http.post(`employee-centre/employees/${id}`, data).then(res => res.data)
    },
    deleteEmployee(_, id) {
      return http.delete(`employee-centre/employees/${id}`)
    },
  },
  getters: {
    departments: state => state.departments,
    employees: state => state.employees,
    stats: state => state.stats,
    currentEmployee: state => state.currentEmployee,
  },
}
